import { SaleOrderInvoiceDetailModel } from "./sale-order-invoice-detail";

// voucher status
export const SALE_ORDER_INVOICES_STATUS_JUST_PLACED = 1;
export const SALE_ORDER_INVOICES_STATUS_APPROVED = 2;
export const SALE_ORDER_INVOICES_STATUS_POSTED = 3;

export const SALE_ORDER_INVOICES_STATUS_NAME = {
  1: 'Just Placed',
  2: 'Approved',
  3: 'Posted',
};

export const SALE_ORDER_INVOICES_STATUS_DROPDOWN_OPTIONS = [
  { value: SALE_ORDER_INVOICES_STATUS_JUST_PLACED, label: SALE_ORDER_INVOICES_STATUS_NAME[SALE_ORDER_INVOICES_STATUS_JUST_PLACED] },
  { value: SALE_ORDER_INVOICES_STATUS_APPROVED, label: SALE_ORDER_INVOICES_STATUS_NAME[SALE_ORDER_INVOICES_STATUS_APPROVED] },
  { value: SALE_ORDER_INVOICES_STATUS_POSTED, label: SALE_ORDER_INVOICES_STATUS_NAME[SALE_ORDER_INVOICES_STATUS_POSTED] },
];


// Invoice Types
export const SALE_ORDER_INVOICES_TYPE_REGULAR = 1;
export const SALE_ORDER_INVOICES_TYPE_ADVANCE = 2;

export const SALE_ORDER_INVOICES_TYPE_NAME = {
  1: 'Regular',
  2: 'Advance',
};

export const FBR_STATUS_NOT_REPORTED = 0;
export const FBR_STATUS_PROCESSING = 1;
export const FBR_STATUS_REPORTED = 2;
export const FBR_STATUS_NOT_TO_BE_REPORTED = 3;

export const FBR_STATUS_NAMES = {
  0: 'Not Reported',
  1: 'Processing',
  2: 'Reported',
  3: 'Not To Be Reported',
};

export const SALE_ORDER_INVOICES_FBR_STATUS_DROPDOWN_OPTIONS = [
  { value: FBR_STATUS_NOT_REPORTED, label: FBR_STATUS_NAMES[FBR_STATUS_NOT_REPORTED] },
  { value: FBR_STATUS_PROCESSING, label: FBR_STATUS_NAMES[FBR_STATUS_PROCESSING] },
  { value: FBR_STATUS_REPORTED, label: FBR_STATUS_NAMES[FBR_STATUS_REPORTED] },
  { value: FBR_STATUS_NOT_TO_BE_REPORTED, label: FBR_STATUS_NAMES[FBR_STATUS_NOT_TO_BE_REPORTED] },
];


export const SALE_ORDER_INVOICES_TYPE_DROPDOWN_OPTIONS = [
  { value: SALE_ORDER_INVOICES_TYPE_REGULAR, label: SALE_ORDER_INVOICES_TYPE_NAME[SALE_ORDER_INVOICES_TYPE_REGULAR] },
  { value: SALE_ORDER_INVOICES_TYPE_ADVANCE, label: SALE_ORDER_INVOICES_TYPE_NAME[SALE_ORDER_INVOICES_TYPE_ADVANCE] },
];

export const SALE_ORDER_INVOICES_DATE_NAMES = {
  1: 'Invoice Date',
  2: 'Invoice Reference Date',
};
export const SALE_ORDER_INVOICES_DATE_TYPE_DROPDOWN_OPTIONS = [
  { value: 1, label: SALE_ORDER_INVOICES_DATE_NAMES[1] },
  { value: 2, label: SALE_ORDER_INVOICES_DATE_NAMES[2] }
];

export const SALE_ORDER_INVOICES_CURRENCY_SYMBOL = 'PKR'


export const IS_COGS_YES = 1;
export const IS_COGS_NO = 0;
export const IS_COGS_NAMES = {
  1: 'Yes',
  0: 'No',
};
export const IS_COGS_DROPDOWN_OPTIONS = [
  { value: IS_COGS_YES, label: IS_COGS_NAMES[IS_COGS_YES] },
  { value: IS_COGS_NO, label: IS_COGS_NAMES[IS_COGS_NO] },
];

export const SaleOrderInvoiceModel = {
  code: 'Auto Generated',
  branch_id: 0,
  is_advance_adjusted: false,
  branch: { name: '' },
  sale_order_id: 0,
  sale_order: { code: '', sod_date: '' },
  party_id: null,
  party: { name: '' },
  project_id: null,
  project: { name: '' },
  invoice_date: '',
  due_date: '',
  type: SALE_ORDER_INVOICES_TYPE_REGULAR,
  remarks: '',
  status: SALE_ORDER_INVOICES_STATUS_JUST_PLACED,
  approved_at: '',
  created_by_id: 0,
  created_by: { name: '' },
  updated_by_id: 0,
  updated_by: { name: '' },
  sale_order_invoice_details: [],
  advance_adjusting: 0,
  amount_after_advance_adjust: 0,
  advance_adjusted: 0
}

export const INVOICING_QUANTITY_ROUND_DECIMAL_PLACES = 6;
